import type { ValidationData } from '@/utils/sampleTypeValidation';
import type { SpreadsheetSettings } from '@/components/UI/SpreadSheet/SpreadSheet.model';
import { MultiSelectEditor } from '@/components/UI/SpreadSheet/editors/MultiSelectEditor';

import {
  buildSampleTypeValidator,
  buildSampleTypeErrorMessage,
  buildLabelValidator,
  buildLabelErrorMessage,
  buildDetailsValidator,
} from '@/components/Modals/BulkEditSampleTypes/BulkEditSampleTypes.utils.shared';

interface HotTableRefLike {
  hotInstance?: unknown;
}

interface BuildColumnsParams {
  availableDetailOptions: Array<string>;
  validationData: ValidationData | null;
  hotTableRef: { current: HotTableRefLike | null };
}

export const buildColumns = ({
  availableDetailOptions,
  validationData,
  hotTableRef,
}: BuildColumnsParams): SpreadsheetSettings['columns'] => {
  const validatorCtx = { validationData, sampleTypes: [], hotTableRef };

  return [
    {
      data: 0,
      value: 'Sample type',
      type: 'text',
      className: 'htMiddle',
      width: 140,
      validator: buildSampleTypeValidator(validatorCtx),
      validationErrorMessage: buildSampleTypeErrorMessage(validationData),
      linkedValidationColumns: ['0'],
    },
    {
      data: 1,
      value: 'Label',
      type: 'text',
      className: 'htMiddle',
      width: 120,
      validator: buildLabelValidator(validatorCtx),
      validationErrorMessage: buildLabelErrorMessage(validationData),
      linkedValidationColumns: ['1'],
    },
    {
      data: 2,
      value: 'Details',
      type: MultiSelectEditor.type,
      className: 'htMiddle',
      width: 280,
      options: availableDetailOptions,
      isMultiSelect: true,
      validator: buildDetailsValidator(availableDetailOptions),
    },
  ];
};

export const initBulkAddSampleTypesSettings = (columns: SpreadsheetSettings['columns']): SpreadsheetSettings => ({
  columns,
  colHeaders: ['Sample type', 'Label', 'Details'],
  rowHeaders: true,
  manualColumnResize: true,
  contextMenu: {
    items: {
      row_above: {},
      row_below: {},
      remove_row: {},
    },
  },
  outsideClickDeselects: false,
  height: 400,
  rowHeights: 50,
  className: 'htMiddle',
  stretchH: 'all',
  minSpareRows: 1,
});
